import { AfImageValue } from "@/types/AfImage";
import { apiPost } from "../_apiShim";

/**
 * Guest additional-field IMAGE upload/read endpoints. Mirrors
 * AttachmentClient's presign→PUT→confirm trio, but scoped to a guest +
 * IMAGE-typed field instead of an attachment definition. Paths per the
 * af-images master spec (2026-07-10):
 *   POST /api/v1/event/{eventId}/guest/{guestId}/af-images/{fieldName}/presign
 *   POST /api/v1/event/{eventId}/guest/{guestId}/af-images/{fieldName}/confirm
 *   POST /api/v1/event/{eventId}/af-images/urls
 */
const BASE_PATH = "/api/v1/event/";

export async function presignAfImageUpload(
  eventId: string,
  guestId: string,
  fieldName: string,
  data: { fileName: string; contentType: string; contentLength: number },
): Promise<{ uploadUrl: string; s3Key: string }> {
  return await apiPost<{ uploadUrl: string; s3Key: string }>(
    `${BASE_PATH}${eventId}/guest/${guestId}/af-images/${encodeURIComponent(fieldName)}/presign`,
    data,
    { "Cache-Control": "no-store" },
    true,
  );
}

export async function confirmAfImageUpload(
  eventId: string,
  guestId: string,
  fieldName: string,
  data: { s3Key: string },
): Promise<AfImageValue> {
  return await apiPost<AfImageValue>(
    `${BASE_PATH}${eventId}/guest/${guestId}/af-images/${encodeURIComponent(fieldName)}/confirm`,
    data,
    { "Cache-Control": "no-store" },
    true,
  );
}

export async function getAfImageUrls(
  eventId: string,
  requests: { guestId: string; fieldName: string }[],
): Promise<{ urls: Record<string, string> }> {
  return await apiPost<{ urls: Record<string, string> }>(
    `${BASE_PATH}${eventId}/af-images/urls`,
    { requests },
    { "Cache-Control": "no-store" },
    true,
  );
}
